import React from 'react';
import { Link } from 'react-router-dom';
const NewTermsContent = ({ pathname, privacyUrl }) => (
  <div className="terms__container">
    <div className="terms__content">
      <div className="terms__content--container">
        <div className="terms__header" />
        <p new-className="new-terms__body">
          These Terms and Conditions constitute a legally binding agreement
          (the “Agreement”) between you (“you” or “your”) and Autzu Inc.
          and/or Autzu Drivesharing Inc. (“Autzu”) for your use of Autzu’s
          drivesharing services (the “Services,” as more fully defined in
          Section 1.1) provided through Autzu’s mobile application (the
          “App”). Please read this Agreement carefully, as it includes
          important information about your legal rights. By accessing
          and/or using the Services, you are agreeing to this Agreement. If
          you do not understand or agree to this Agreement, please do not
          use the Services.
        </p>
        <p>
          <b>
            Please note that Section 27 contains an arbitration clause and
            class action waiver. By agreeing to this Agreement, you agree
            (a) to resolve all disputes with us through binding individual
            arbitration, which means that you waive any right to have those
            disputes decided by a judge or jury, and (b) that you waive
            your right to participate in class actions, class arbitrations,
            or representative actions.{' '}
          </b>
        </p>
        <h3 className="subheading">1. General</h3>
        <ul>
          <p className="new-terms__body">
            1.1 Both parties recognize and agree that this Agreement is not
            an Employment Agreement and that the relationship between the
            parties remains at-will. This Agreement supersedes all previous
            agreements and understandings between the parties.
          </p>
          <p className="new-terms__body">
            1.2 Your relationship with Autzu will at all times be that of
            an independent contractor and nothing in this Agreement should
            be construed to create a partnership, joint venture, or
            employer-employee relationship. You will not be entitled to any
            of the benefits which Autzu may make available to its
            employees, such as profit-sharing or retirement benefits, and
            you will not be eligible for, and shall not participate in or
            apply for, any Autzu-provided employee benefit plan or program.
            You will be solely responsible for all tax returns and payments
            required to be filed with or made to any federal, state or
            local tax authority with respect to your driving a Vehicle.
            Because you are an independent contractor, Autzu will not
            withhold or make payments for social security, make
            unemployment insurance or disability insurance contributions,
            or obtain worker’s compensation insurance on your behalf. You
            agree to accept exclusive liability for complying with all
            applicable state, local, and federal laws governing
            self-employed individuals, including, without limitation,
            obligations such as payment of taxes, social security,
            disability and other contributions based on all amounts paid to
            you with respect to your use of a Vehicle.
          </p>
          <p className="new-terms__body">
            1.3 This Agreement supersedes all previous agreements and
            understandings between the parties and constitutes the entire
            understanding between the parties hereto.
          </p>
          <p className="new-terms__body">
            1.4 By creating an account, you agree to allow Autzu to create,
            manage and modify your individual driver account[s] on
            ridesharing platforms.
          </p>

          <p className="new-terms__body">
            1.5 Autzu shall not be liable for any acts or omissions by you
            that occur while you are using a Vehicle.
          </p>
        </ul>
        <h3 className="subheading">2. Who May Use the Services </h3>
        <ul>
          <p className="new-terms__body">
            2.1 You must be 21 years of age or older, pass criminal and
            driver record checks and be eligible to operate as a FHV driver
            in the city of operation to use the Services. By using the
            Services, you represent and warrant that you meet these
            requirements.
          </p>
        </ul>
        <h3 className="subheading">3. Autzu and Rideshare Accounts</h3>
        <ul>
          <p className="new-terms__body">
            3.1 To use the Services, you need to create an Autzu Account
            (“Account”). After you create an Account, you agree to provide
            us with accurate, complete and updated information for your
            Account. You can access, edit and update your Account through
            the App. You are solely responsible for any activity on your
            Account and for maintaining the confidentiality and security of
            your password. We are not liable for any acts or omissions by
            you in connection with your Account. You must immediately
            notify us at info@autzu.com if you know or have any reason to
            suspect that your Account or password have been stolen,
            misappropriated or otherwise compromised, or in case of any
            actual or suspected unauthorized use of your Account.
          </p>
          <p className="new-terms__body">
            3.2 You must connect your Rideshare Account to the Autzu system
            for us to maintain updated vehicle information on your
            ridesharing accounts. This information includes but is not
            limited to, documents related to vehicle registration,
            insurance, safety certificates, and other information such as
            earnings, trips, HST and more.
          </p>
          <p className="new-terms__body">
            3.3 A ‘Rideshare Account’ is your services account with any
            ridesharing, car-rental, car-sharing or related business
            entities including but not limited to Via, Uber, Lyft and
            others
          </p>
          <p className="new-terms__body">
            3.4 By connecting your Rideshare Account, you authorize Autzu
            to fully access, save your information, or make any changes to
            your account on your behalf. It is understood that there may be
            single or multiple ridesharing accounts associated with your
            Autzu account.
          </p>
          <p className="new-terms__body">
            3.5 Autzu will only use your Rideshare Account authorization
            within the scope of the services provided; and will never
            disclose your private information to any third party with
            accordance with our
            <a href={privacyUrl}> Privacy Policy</a>
          </p>
        </ul>
        <h3 className="subheading">4. Vehicle Use</h3>
        <ul>
          <p className="new-terms__body">
            4.1 “Rideshare Operations” defines your use of a Vehicle to
            generate earnings on ridesharing platforms including but not
            limited to Via, Uber, Lyft and others. The following provisions
            of this section pertain to rules and requirements for your
            engagement in Rideshare Operations.
          </p>
          <p className="new-terms__body">
            4.2 You are permitted to book and drive a Vehicle for a minimum
            duration of 6 hours, up to a maximum of 7 consecutive days. To
            extend your booking beyond the 7-day limit, it is mandatory to
            return the Vehicle promptly at the end of the 7-day period and
            make a new booking for any additional time required. You are
            responsible for adhering to the specified booking duration and
            returning the Vehicle promptly upon the completion of your
            reservation.
          </p>
          <p className="new-terms__body">
            4.3 You must maintain a valid driver’s license for the type of
            Vehicle that you are operating and notify Autzu immediately if
            you no longer have a valid license.
          </p>
          <p className="new-terms__body">
            4.4 You will notify Autzu of any citations received while
            operating a Vehicle. You will be financially responsible for
            any fines, penalties and court costs for parking, traffic,
            tolls, and other violations, including storage liens and
            charges.
          </p>
          <p className="new-terms__body">
            4.5 You are responsible for maintaining a clean driver's
            abstract within established Autzu guidelines, and this abstract
            can be reviewed at any time by Autzu.
          </p>
          <p className="new-terms__body">
            4.6 You must follow accepted safe driving practices and obey
            all road and traffic regulations.
          </p>
          <p className="new-terms__body">
            4.7 You will ensure that all Vehicle occupants are properly
            wearing safety belts while a Vehicle is in motion.
          </p>
          <p className="new-terms__body">
            4.8 You agree to operate the Vehicle in a safe manner that will
            not expose Autzu to excessive liability or risk.
          </p>
          <p className="new-terms__body">
            4.9 Only you are permitted to drive the Vehicle. Under no
            circumstances should any other person operate a Vehicle without
            the prior written consent of Autzu.
          </p>
          <p className="new-terms__body">
            4.10 Only you are permitted to be inside the Vehicle when you
            are offline on the Autzu or ridesharing mobile applications.
            Under no circumstances should any passenger(s) be inside a
            Vehicle when you are not using the Autzu or ridesharing mobile
            applications.
          </p>
          <p className="new-terms__body">
            4.11 By agreeing to engage in ride-sharing activities, you may
            not use the car for personal use or transport non-rideshare
            passengers.
          </p>
          <p className="new-terms__body">
            4.12 You are responsible for parking in safe and legal areas.
          </p>
          <p className="new-terms__body">
            4.13 You may only pick up passengers through rideshare
            providers. Hitchhikers or cash trips are not permitted.
          </p>
          <p className="new-terms__body">
            4.14 Towing of mobile homes, travel trailers or any type of
            recreational or utility trailer with the Vehicle is prohibited.
          </p>
          <p className="new-terms__body">
            4.15 You may not use alcohol or controlled substances prior to
            and/or during the operation of a Vehicle.
          </p>
          <p className="new-terms__body">
            4.16 You may not smoke inside a Vehicle. If you are found to
            have done so, you may be assessed a fee as liquidated damages
            and not as a penalty in accordance with Autzu’s then-current
            policies or the Services may be terminated.
          </p>
          <p className="new-terms__body">
            4.17 You may not carry inside a Vehicle any hazardous
            substances, chemicals, or dangerous goods, as defined by law.
          </p>
          <p className="new-terms__body">
            4.18 You may not make modifications to a Vehicle, including
            removing branding vinyls and stickers.
          </p>
          <p className="new-terms__body">
            4.19 You are not permitted to sign or enter into an agreement
            on behalf of Autzu to perform any services on Autzu's vehicles
            except with prior written consent from Autzu. Any agreements
            you sign without Autzu's prior consent will be deemed invalid
            and all costs associated with recovering the damages caused
            will be billed to you directly.
          </p>
          <p className="new-terms__body">
            4.20 If a Vehicle is unavailable due to Autzu’s maintenance or
            repair, you may still be able to drive a Vehicle once one is
            available. You will be charged at an adjusted price based on
            the remaining available hours.
          </p>
          <p className="new-terms__body">
            4.21 You are not permitted to tamper, cover, or remove any
            cameras or sensors on the Vehicles. Cameras may be used for the
            safety of our drivers and used in the event of an accident to
            assist with the Insurance claim process.
          </p>
          <p className="new-terms__body">
            4.22 Autzu EV Vehicles have the speed and acceleration
            restricted, and the glove box compartment locked for safety.
            You must not attempt to remove these limits. Doing so will
            result in permanent account termination.
          </p>
          <p className="new-terms__body">
            4.23 Using Tesla Autopilot features is not recommended by Autzu
            and is solely Your responsibility to the safety of the vehicle.
            Accidents occuring during the use of using such features is
            Your responsibility.
          </p>
          <p className="new-terms__body">
            4.24 Using Tesla Entertainment or Gaming features are not
            permitted and subject to a data fair usage policy. Your Autzu
            account will be cancelled if we deem you are using such
            features excessively and using an abnormal amount of data
            usage.
          </p>
        </ul>
        <h3 className="subheading" id="earnings">
          5. Fees
        </h3>
        <ul>
          <p className="new-terms__body">
            5.1 To engage in Rideshare Operations, you will pay a Vehicle
            booking fee (“Booking Fee”) that starts at $7 an hour (EV) for
            a minimum duration of 6 hours. More information on Autzu’s
            Booking Fees can be found at{' '}
            <a href="https://www.autzu.com">www.autzu.com</a> or in the
            Autzu App. Your earnings will also be subject to any relevant
            fees and commissions by the ridesharing mobile applications
            (“Service Fee”).
          </p>
          <p className="new-terms__body">
            5.2 Refund Policy: Please note that no refunds will be issued
            directly to your method of payment. In the rare event that a
            refund is agreed upon, the corresponding amount will not be
            returned to your original method of payment. Instead, the
            amount will be credited to your Autzu account for future use.
            The decision to provide a refund is entirely at Autzu's
            discretion and is not guaranteed in any circumstance.
          </p>
        </ul>
        <h3 className="subheading">6. Earnings and Payments</h3>
        <ul>
          <p className="new-terms__body">
            6.1 You must provide a valid credit or debit charge card to
            make a booking. Autzu rental fees are charged to your credit or
            debit card before the start of your booking.
          </p>
          <p className="new-terms__body">
            6.2 Autzu will verify your payment information by performing an
            authorization charge to verify the authenticity of the card on
            your profile.
          </p>
          <p className="new-terms__body">
            6.3 You must provide true, accurate, and complete information
            about your payment information and maintain updated payment
            information. If you provide information that is untrue,
            inaccurate, or incomplete, or we have reason to believe that
            such information is untrue, inaccurate, or incomplete, we
            reserve the right to terminate your Autzu account or take
            appropriate legal action.
          </p>
          <p className="new-terms__body">
            6.4 By sharing the details of your credit or debit card, you
            authorize Autzu to store this information and charge this card
            for Autzu booking fees, damage charges, or other deductions
            that are applicable to you.
          </p>
          <p className="new-terms__body">
            6.5 You agree to allow Autzu to collect your rideshare earnings
            data from ridesharing platforms to ensure the intended use of
            the vehicles is as defined “Rideshare Operations”
          </p>
          <p className="new-terms__body">
            6.6 You agree to allow Autzu to charge all Vehicle booking fees
            (“Booking Fee”) to the Payment Method provided on your Autzu
            Account, in addition to other fees including but not limited to
            late vehicle return, tickets, and damages.
          </p>
          <p className="new-terms__body">
            If using the Via platform in NYC, you have the choice to
            either:
            <br />
            a) Allow the amount of your Booking Fees and up to $500 of any
            other fees owed to Autzu under this agreement (the “Autzu
            Obligations”) to be automatically deducted on a weekly basis
            from your Via Driver Partner weekly earnings (the “Earnings
            Deduction”) otherwise owed to you from Flatiron Transit, LLC,
            (“Flatiron”) (a TLC-licensed black car base and wholly-owned
            subsidiary of Via Transportation, Inc. (“Via”)), or any other
            black car service owned by or affiliated with Via and licensed
            by the TLC. The earnings deduction shall then be forwarded in
            total to Autzu in satisfaction of the Autzu Obligations, or
            <br />
            b) Forego the convenience of your fees owed to Autzu being
            deducted from your Via Driver Partner weekly earnings, and
            instead independently pre-pay any fees owed to Autzu by credit
            card (including a 4% processing fee) by emailing
            drivers@autzu.com (or, once available, by selecting this option
            on the Autzu platform) and following the instructions provided
            to you thereafter. In addition to the pre-payment process, you
            must provide a refundable deposit of $500, payable immediately
            upon your request for this payment option. The deposit will be
            fully refundable either after i) closure of your account or ii)
            changing the method of payment, given there are no outstanding
            fees on your account.
            <br />
          </p>
          <p className="new-terms__body">
            <b>
              YOU ARE HEREBY DEEMED TO CHOOSE OPTION (a) ABOVE (EARNINGS
              DEDUCTION) UNLESS YOU EMAIL NYC@AUTZU.COM AT LEAST THREE (3)
              DAYS BEFORE THE NEXT SCHEDULED EARNINGS DEDUCTION DATE TO
              NOTIFY THEM OF YOUR INTENT TO CHOOSE OPTION (b), IN WHICH
              CASE OPTION (b) WILL APPLY TO ALL FEES INCURRED AFTER YOU
              NOTIFY AUTZU, UNLESS AND UNTIL YOU NOTIFY AUTZU OTHERWISE.
            </b>
          </p>
          <p className="new-terms__body">
            <b>
              You will independently pay any fees owed to Autzu in excess
              of the amounts paid under either (a) or (b), as applicable,
              by credit card (including processing fees) within 24 hours of
              the due date in the manner instructed by Autzu.
            </b>
          </p>
        </ul>
        <h3 className="subheading" id="cancel">
          7. Booking and Cancellation Policy
        </h3>
        <ul>
          <p className="new-terms__body">
            7.1 The following cancellation policy applies to all bookings
            which are made using the App. You must cancel a time slot
            through the App. There is no cancellation fee for cancellations
            made more than 24 hours before the start of the time slot. A
            cancellation fee equal to 50% of the total booking fee will
            apply for cancellations made between 24 hours to 2 hours from
            the start of the time slot. A cancellation fee equal to 100% of
            the total booking fee will apply for cancellations made within
            2 hours from the start of the time slot (after the vehicle is
            assigned to you).
          </p>
        </ul>
        <h3 className="subheading">8. Recharging the Vehicle </h3>
        <ul>
          <p className="new-terms__body">
            8.1 Autzu will do its best to provide vehicles with at least a
            70% battery charge level at the start of your time slot, by
            enforcing its strict EV charging policies. Autzu cannot
            guarantee a full charge.
          </p>
          <p className="new-terms__body">
            8.2 As the renter of the electric vehicle, you shall assume
            responsibility for charging the vehicle at the closest Tesla
            Supercharger or any third-party charging station as required.
            You shall be responsible for covering any expenses related to
            the charging process, including but not limited to electric
            charging costs, parking entrance fees for accessing the
            chargers, and idle fees, among others.
          </p>
          <p className="new-terms__body">
            8.3 Failure to return the Vehicle with at least 70% battery
            level when returning the vehicle will result in an additional
            charge as specified by Autzu on the Help page of the Autzu App.
          </p>
          <p className="new-terms__body">
            8.4 Range estimates displayed on the Tesla screen or Autzu app
            are subject to variations based on weather conditions, driving
            patterns, air conditioning usage, and road conditions. You are
            solely responsible for ensuring that the vehicle remains
            sufficiently charged and must take all necessary measures to
            avoid any situation where the vehicle runs out of charge.
          </p>
          <p className="new-terms__body">
            8.5 You are solely responsible for all expenses associated with
            charging the electric vehicle. When you charge the electric
            vehicle at a Tesla Supercharging station, Autzu will cover the
            cost initially and subsequently add the charges to your
            account. If you charge the electric vehicle at a third-party
            station, you are responsible for paying the charging fee
            directly to the provider.
          </p>
          <p className="new-terms__body">
            8.6 You must comply with all safety and safe use procedures
            when using Tesla Superchargers. Please put the charge plug back
            in its holster at the end of your charging session to avoid
            damage and abuse.
          </p>
          <p className="new-terms__body">
            8.7 Tesla Supercharger “Idle fees” apply to any Vehicle
            occupying a Supercharger if the station is at least 50% full
            and once the charge session is complete. If the car is moved
            within 5 minutes of the charge session completion, the fee is
            waived. You will be responsible for any Idle fees incurred.
            More details here.
          </p>
          <p className="new-terms__body">
            8.8 A $20 charge will apply if you do not plug in the EV
            charger at the end of your time slot, when the car is returned
            to the Autzu Parking Hub and your booking is ended.
          </p>
          <p className="new-terms__body">
            8.9 You will be responsible for paying a fee of $250 if you run
            out of battery completely (0%) plus any towing and recovery
            fees. Your Autzu account may also be terminated for negligence.
          </p>
        </ul>
        <h3 className="subheading">9. Car Access</h3>
        <ul>
          <p className="new-terms__body">
            9.1 You are responsible for the safe and secure operation of
            the Vehicle key lockbox and/or other electronic equipment
            installed by Autzu on the Vehicle to allow remote access to the
            Vehicle through the Autzu App.{' '}
          </p>
          <p className="new-terms__body">
            9.2 Vehicle access tampering/misuse will result in a permanent
            cancellation of your Autzu account and/or additional fees
            resulting from the recovery of the vehicle and/or repair of the
            Vehicles security system.
          </p>
          <p className="new-terms__body">
            9.3 The ability to lock and unlock the Vehicle is provided
            using data and requires you to have a sufficient data plan on
            your phone at all times during your time slot. You must avoid
            areas where LTE signal is limited, as you will be unable to
            lock, unlock or start the motor of the Vehicle. You will be
            responsible for all towing and recovery costs associated with
            recovering a Vehicle from a location where there is no data
            signal.
          </p>
          <p className="new-terms__body">
            9.4 If a physical key card is provided to You in order to
            access the Vehicle, you must return it to the correct location
            at the end of your time slot, without modifying the PIN code of
            the glove box compartment.
          </p>
        </ul>
        <h3 className="subheading">10. Accidents</h3>
        <ul>
          <p className="new-terms__body">
            10.1 In the event of an accident, you will follow the steps
            provided in the Accidents and Insurance section of the Help
            page located in the Autzu App.
          </p>
          <p className="new-terms__body">
            10.2 If you are involved in an accident while using a Vehicle
            your access to the use of Autzu App for bookings may be
            suspended while Autzu conducts an incident investigation.
          </p>
          <p className="new-terms__body">
            10.3 For any Vehicle damage that you cause, Autzu will issue an
            invoice for the repair costs. Payment of the invoice is due
            upon receipt. Autzu reserves the right to charge up to 100% of
            the cost to your Payment Method provided. In some cases, Autzu
            may agree to a payment plan to finance the repair costs over a
            reasonable period of time. Any unpaid amounts will be sent to
            collections if not paid within thirty (30) days. Interest on
            overdue amounts will start to accrue after 30 days.
          </p>
          <p className="new-terms__body">
            10.5 You will be responsible for any deductibles and charges
            (including "loss of use" at a rate of $100 per day) if the
            accident is deemed avoidable (at fault).
          </p>
          <p className="new-terms__body">
            10.6 You are not permitted to authorize an Autzu vehicle to be
            towed from a scene of an accident, or sign a work order for the
            repair of an Autzu vehicle at any repair facility that is not
            approved by Autzu. You must wait for an Autzu authorized towing
            vendor to tow the vehicle from the scene of an accident to an
            Autzu authorized repair facility.
          </p>
        </ul>
        <h3 className="subheading">11. Inspections and Vehicle Damage</h3>
        <ul>
          <p className="new-terms__body">
            11.1 Prior to taking possession of a Vehicle, you must complete
            a full exterior and interior inspection. You must immediately
            notify Autzu of any damage or abnormalities found on or in the
            Vehicle before or during the operation of the Vehicle. This
            includes but is not limited to visible damage, warning lights,
            indication of leaking fluids, cracks or chips in the
            windscreen, a missing or inoperable signal or driving light,
            broken or missing mirrors, or any other condition that may
            render the Vehicle unsafe to operate.
          </p>
          <p className="new-terms__body">
            11.2 You will be fully liable for the cost of repair of any
            unreported damage(s) on a Vehicle once you begin to operate it.
            You authorize us to charge you for the actual cost of repair or
            replacement of lost or damaged items such as glass, mirrors,
            tires, and antenna, as part of your rental charges at the time
            of return.
          </p>
          <p className="new-terms__body">
            11.3 Aside from normal wear and tear, you will be liable for
            tire punctures, cuts, bursts, or any tire damage that occurs
            during your time slot. For a side puncture or tire damage that
            is irreparable, a $250 + labor installation fee charge will
            apply for the cost of a replacement tire.
          </p>
          <p className="new-terms__body">
            11.4 Under no circumstances will you drive a Vehicle with any
            warning lights on the dashboard, without informing us first and
            receiving consent that the vehicle is safe to continue driving.
            You must contact Autzu by phone, text or email so we can
            provide the appropriate steps to resolve the issue or change
            you to another Vehicle.
          </p>
        </ul>
        <h3 className="subheading">12. Return of the Vehicle</h3>
        <ul>
          <p className="new-terms__body">
            12.1 You agree to return the Vehicle in the same condition it
            was received, ordinary wear and tear excepted, at the end of
            your time slot and to the parking location specified. If
            requested by Autzu, you must return the Vehicle immediately,
            even if the request occurs during your time slot.
          </p>
          <p className="new-terms__body">
            12.2 You will be responsible for late fees, as well as all
            charges, damages, or losses to a Vehicle (specific to the
            tardiness of the vehicle return) if it is not returned by the
            end of your time slot. Liquidated damages for Autzu’s loss of
            use will be imposed until the Vehicle is returned to the
            specified parking location. Fee amounts and structure can be
            found in the Autzu App Help section.
          </p>
          <p className="new-terms__body">
            12.3 You must ensure that all of your personal items are
            removed from the vehicle upon termination of the rental period.
            Any items left behind will be retained for a maximum period of
            seven days. Autzu disclaims all liability for the loss or
            misplacement of personal items left within the vehicle.
          </p>
        </ul>
        <h3 className="subheading">
          13. Expenses, Costs, and Administrative Fees{' '}
        </h3>
        <ul>
          <p className="new-terms__body">
            13.1 You will pay an administrative fee for any action that
            Autzu must take due to your violation of the Agreement. Such
            administrative fees include but are not limited to costs for
            repossessing or recovering a Vehicle, and will be determined at
            Autzu’s reasonable discretion.
          </p>
          <p className="new-terms__body">
            13.2 For any traffic violation, Autzu will apply the face value
            of the ticket, plus any administration or late fees, to your
            Autzu account and pay the ticket immediately on your behalf.
            There is no option to appeal a traffic violation. For any
            tolls, Autzu will apply the total toll amounts to your Autzu
            account on a monthly basis.
          </p>
          <p className="new-terms__body">
            13.3 If you do not pay outstanding tickets or fines within
            seven (7) days of them being issued, you agree to Autzu
            charging the amount plus an administrative fee to the credit
            card stored on file, if any.
          </p>
          <p className="new-terms__body">
            13.4 You agree and acknowledge that Autzu cooperates with all
            federal, state, provincial, municipal, and local officials
            charged with enforcing these infractions to provide any
            information that may be requested or required.
          </p>
          <p className="new-terms__body">
            13.5 You authorize Autzu to release your personal credit or
            debit card information to Autzu’s agent for the purpose of
            processing and billing you for any tickets, citations, fines,
            and penalties incurred or assessed against Autzu or a Vehicle
            during your use if payment is refused.
          </p>
          <p className="new-terms__body">
            13.6 If Autzu uses a third-party collection or administrative
            agent to resolve any tickets, citations, fines, and penalties,
            you agree to pay all costs and collection fees, including but
            not limited to administrative and legal costs to such agent.
            You agree to indemnify and hold Autzu and its agents harmless
            for any tickets, citations, fines, penalties, and
            administrative fees.
          </p>
          <p className="new-terms__body">
            13.7 In the event that the vehicle or items related to our
            services are impounded due to any violation of these terms or
            any applicable laws or regulations, you will be held
            responsible for the cost of the impoundment. This cost includes
            an impound fee of $100 per day for the duration of the
            impoundment and any associated towing and recovery fees that
            may be incurred as a result of the impoundment.
          </p>
        </ul>
        <h3 className="subheading">14. Vehicle Maintenance </h3>
        <ul>
          <p className="new-terms__body">
            14.1 Autzu will perform regular scheduled maintenance including
            but not limited to oil changes, brake services, safety
            inspections and tire replacements to ensure the Vehicle is safe
            to drive and compliant with all federal, state and local
            regulations.
          </p>
          <p className="new-terms__body">
            14.2 Autzu will perform interior and exterior cleaning on a
            regular scheduled basis. Due to the high utilization of the
            Vehicles, a perfectly clean interior and exterior is not
            guaranteed. You will be charged a fee if a Vehicle is returned
            in an excessively dirty condition requiring extra cleaning or
            deodorizing, which includes but is not limited to, spillage of
            fluids, food, vomit, other stains, and unpleasant odors,
            including cigarette smoke.
          </p>
          <p className="new-terms__body">
            14.3 Autzu acknowledges and complies with the legal obligations
            imposed by the City of Toronto and City of Mississauga bylaw
            for ridesharing. Pursuant to these bylaws, it is mandated that
            all Autzu vehicles shall be equipped with winter tires from
            December 1 until April 30. Autzu assumes full responsibility
            for ensuring the installation and maintenance of winter tires
            on all vehicles during the specified period, as required by
            law.
          </p>
        </ul>
        <h3 className="subheading">
          15. License Grant and Intellectual Property Ownership{' '}
        </h3>
        <ul>
          <p className="new-terms__body">
            15.1 Subject to your compliance with this Agreement, Autzu
            hereby grants to you, a personal, worldwide, royalty-free,
            non-assignable, non-sublicensable, non-transferrable, and
            non-exclusive license to access and use the App provided to you
            as part of the Services, and to download a single copy of the
            App onto your personal device. This license has the sole
            purpose of enabling you to use and enjoy the benefit of the
            Services as provided by us, in the manner permitted by this
            Agreement and subject to the use restrictions described below.
          </p>
          <p className="new-terms__body">
            15.2 The Services, including their "look and feel" (e.g., text,
            graphics, images, logos), proprietary content, information and
            other materials, are protected under copyright, trademark and
            other intellectual property laws. You agree that Autzu and/or
            its licensors own all right, title and interest in and to the
            Services (including any and all intellectual property rights
            therein) and you agree not to take any action(s) inconsistent
            with such ownership interests. We and our licensors reserve all
            rights in connection with the Services and its content,
            including, without limitation, the exclusive right to create
            derivative works. Autzu’s name, trademark, logo, and all
            related names, logos, product and service names, designs, and
            slogans are trademarks of Autzu or its affiliates or licensors.
            Other names, logos, product and service names, designs and
            slogans that appear on the Services are the property of their
            respective owners, who may or may not be affiliated with,
            connected to, or sponsored by Autzu.
          </p>
        </ul>
        <h3 className="subheading">
          16. Restrictions On Your Use of the Services{' '}
        </h3>
        <ul>
          <p className="new-terms__body">
            16.1 You are not permitted to download, modify, copy,
            distribute, transmit, display, perform, reproduce, duplicate,
            publish, license, create derivative works from, or offer for
            sale any information contained on, or obtained from or through,
            the Services;
          </p>
          <p className="new-terms__body">
            16.2 You are not permitted to duplicate, decompile, reverse
            engineer, disassemble or decode the Services (including any
            underlying idea or algorithm), or attempt to do any of the
            same;
          </p>
          <p className="new-terms__body">
            16.3 You are not permitted to use, reproduce or remove any
            copyright, trademark, service mark, trade name, slogan, logo,
            image, or other proprietary notation displayed on or through
            the Services;
          </p>
          <p className="new-terms__body">
            16.4 You are not permitted to use cheats, automation software
            (bots), hacks, modifications (mods) or any other unauthorized
            third-party software designed to modify the Services;
          </p>
          <p className="new-terms__body">
            16.5 You are not permitted to exploit the Services for any
            commercial purpose, including without limitation communicating
            or facilitating any commercial advertisement or solicitation;
          </p>
          <p className="new-terms__body">
            16.6 You are not permitted to access or use the Services in any
            manner that could disable, overburden, damage, disrupt or
            impair the Services or interfere with any other party's access
            to or use of the Services or use any device, software or
            routine that causes the same;
          </p>
          <p className="new-terms__body">
            16.7 You are not permitted to attempt to gain unauthorized
            access to, interfere with, damage or disrupt the Services,
            Accounts registered to other users, or the computer systems or
            networks connected to the Services;
          </p>
          <p className="new-terms__body">
            16.8 You are not permitted to circumvent, remove, alter,
            deactivate, degrade or thwart any technological measure or
            content protections of the Services; or
          </p>
          <p className="new-terms__body">
            16.9 You are not permitted to access or use the Services in any
            way not expressly permitted by this Agreement.
          </p>
        </ul>
        <h3 className="subheading">
          17. Use of the Autzu App and Location Services
        </h3>
        <ul>
          <p className="new-terms__body">
            17.1 You are responsible for providing the mobile device,
            wireless service plan, Internet connections and/or other
            equipment or services that you need to download, install, and
            use the Autzu App, and any other Apps required.
          </p>
          <p className="new-terms__body">
            17.2 We do not guarantee that the App can be accessed and used
            on any particular device or with any particular service plan.
            We do not guarantee that the App will be available in any
            particular geographic location.
          </p>
          <p className="new-terms__body">
            17.3 Autzu requires permission to use location services on your
            mobile device. Location data helps Autzu improve its services
            and allows for vehicle tracking, helps Autzu improve driver and
            car safety, and more.
          </p>
        </ul>
        <h3 className="subheading">18. Autzu Communications </h3>
        <ul>
          <p className="new-terms__body">
            18.1 As part of the Services and to update you, you may receive
            push notifications, local notifications, text messages, picture
            messages, alerts, emails, or other types of messages directly
            sent to you in connection with the App (“Push Messages”). You
            acknowledge that, when you use the App, your wireless service
            provider may charge you fees for data, text messaging and/or
            other wireless access, including in connection with Push
            Messages. You have control over the Push Messages settings, and
            can opt-in or out of these Push Messages through the Services
            or through your mobile device’s operating system (with the
            possible exception of infrequent, important service
            announcements and administrative messages). Please check with
            your wireless service provider to determine what fees apply to
            your access to and use of the App, including your receipt of
            Push Messages from Autzu. You are solely responsible for any
            fee, cost or expense that you incur to download, install and/or
            use the App on your mobile device, including for your receipt
            of push messages from Autzu.
          </p>
          <p className="new-terms__body">
            18.2 Certain portions of the Services may allow us to contact
            you via telephone or text messages. You agree that Autzu may
            contact you via telephone or text messages (including by an
            automatic telephone dialing system) at any of the phone numbers
            provided by you or on your behalf in connection with your use
            of the Services, including for marketing purposes. You
            understand that you are not required to provide this consent as
            a condition of using the Services. You also understand that you
            may opt-out of receiving text messages from us at any time by
            contacting Autzu by phone, text, or email or by selecting the
            opt-out function on the App. If you do not choose to opt-out,
            we may contact you as outlined in our Privacy Policy.
          </p>
        </ul>
        <h3 className="subheading">
          19. Mobile Software from the Apple App Store{' '}
        </h3>
        <ul>
          <p className="new-terms__body">
            19.1 The following section applies to you only if you are using
            the App from the Apple App Store. To the extent the other terms
            and conditions of this Agreement are less restrictive than, or
            otherwise conflict with, the terms and conditions of this
            paragraph, the more restrictive or conflicting terms and
            conditions in this paragraph apply, but solely with respect to
            the App from the Apple App Store. You acknowledge and agree
            that this Agreement is solely between you and Autzu, not Apple,
            and that Apple has no responsibility for the App or content
            thereof. Your use of the App must comply with the App Store’s
            applicable terms of use. You acknowledge that Apple has no
            obligation whatsoever to furnish any maintenance and support
            services with respect to the App. To the maximum extent
            permitted by applicable law, Apple will have no other warranty
            obligation whatsoever with respect to the App, and any other
            claims, losses, liabilities, damages, costs or expenses
            attributable to any failure to conform to any warranty will be
            solely governed by this Agreement. You and Autzu acknowledge
            that Apple is not responsible for addressing any claims of
            yours or any third party relating to the App or your possession
            and/or use of the App, including, but not limited to: (a)
            product liability claims, (b) any claim that the App fails to
            conform to any applicable legal or regulatory requirement, and
            (c) claims arising under consumer protection or similar
            legislation. You and Autzu acknowledge that, in the event of
            any third party claim that the App or your possession and use
            of that App infringes that third party’s intellectual property
            rights, Autzu, not Apple, will be solely responsible for the
            investigation, defense, settlement and discharge of any such
            intellectual property infringement claim to the extent required
            by this Agreement. You must comply with applicable third-party
            terms of agreement when using the App. You and Autzu
            acknowledge and agree that Apple, and Apple’s subsidiaries, are
            third party beneficiaries of this Agreement as they relate to
            your use of the App, and that, upon your acceptance of this
            Agreement, Apple will have the right (and will be deemed to
            have accepted the right) to enforce this Agreement against you
            as a third-party beneficiary thereof.
          </p>
        </ul>
        <h3 className="subheading">
          20. Mobile Application from Google Play
        </h3>
        <ul>
          <p className="new-terms__body">
            20.1 The following section applies to you only if you are using
            the App through Google, Inc. or one of its affiliates
            (“Google”) via Google Play or its successor(s). If there is any
            conflict between the Google Terms of Service and the Google
            Play Business and Program Policies or such other terms which
            Google designates as default end user license terms for Google
            Play (all of which together are referred to as the “Google Play
            Terms”), the Google Play Terms shall apply with respect to your
            use of the Services that you acquire from Google Play. You
            hereby acknowledge that Google does not have any responsibility
            or liability related to compliance or non-compliance by Autzu
            or you (or any other user) under this Agreement or the Google
            Play Terms.]
          </p>
        </ul>
        <h3 className="subheading">21. Privacy Policy</h3>
        <ul>
          <p className="new-terms__body">
            21.1 Our Privacy Policy describes how we handle the information
            you provide to us when you use the Services. For an explanation
            of our privacy practices, please visit our Privacy Policy
            located at{' '}
            <Link
              to={
                pathname.includes('tor')
                  ? '/tor/privacy'
                  : pathname.includes('sf')
                  ? '/sf/privacy'
                  : '/nyc/privacy'
              }>
              autzu privacy
            </Link>
            .
          </p>
        </ul>
        <h3 className="subheading">22. Term and Termination</h3>
        <ul>
          <p className="new-terms__body">
            22.1 The Agreement is effective upon your creation of an
            Account on the App. This Agreement may be terminated by either
            party at any time with or without cause upon [30] days’ prior
            written notice. Autzu may also suspend, disable, or delete your
            Account, or any part of the foregoing, with or without notice,
            for any or no reason. If Autzu deletes your Account for any
            suspected breach of this Agreement by you, you are prohibited
            from re-registering for the Services under a different name.
            All sections which by their nature should survive the
            termination of this Agreement shall continue in full force and
            effect subsequent to and notwithstanding any termination of
            this Agreement by Autzu or you. Termination will not limit any
            of Autzu’s other rights or remedies at law or in equity.
          </p>
        </ul>
        <h3 className="subheading">23. Confidentiality</h3>
        <ul>
          <p className="new-terms__body">
            23.1 You acknowledge and agree that the Service consists of
            operational and other information that is the confidential
            information of Autzu (“Confidential Information”). You agree to
            hold the Confidential Information in strict confidence. You may
            not use or reproduce the Confidential Information for any
            purpose except as specifically permitted under this Agreement
            or disclose any of the Confidential Information or any
            information derived therefrom to any third party without the
            prior written permission of Autzu. You agree to notify Autzu in
            writing immediately if you become aware of or suspect that the
            security of the Confidential Information has or may be
            compromised in any way. The foregoing restrictions do not apply
            to information that without breach of any obligation by you
            that you can demonstrate: (i) is or becomes publicly available;
            (ii) was known to you prior to its disclosure by Autzu; or
            (iii) was independently developed by you without reference to
            any information you received from Autzu.
          </p>
        </ul>
        <h3 className="subheading">24. Representations and Warranties</h3>
        <ul>
          <p className="new-terms__body">
            24.1 You hereby represents and warrants that (a) you are an
            individual who can form legally binding contracts under
            applicable law and carry out the provisions hereof, (b) your
            execution, delivery and performance of this Agreement does not
            conflict with any agreement, instrument or understanding, oral
            or written, to which you are a party or by which you may be
            bound, nor violate any law or regulation of any court,
            governmental body or administrative or other agency having
            jurisdiction over it, (c) you will not violate any applicable
            law or regulation in connection with your access to or use of
            the Services, (d) while engaging in drivesharing operations,
            you will at all times refrain from participating in any
            illegal, unfair, deceptive or unethical business practices, and
            (e) you will not incur any liability on behalf of Autzu nor in
            any way pledge or purport to pledge Autzu’s credit or purport
            to make any contract binding upon Autzu.
          </p>
        </ul>
        <h3 className="subheading">25. Warranty Disclaimers</h3>
        <ul>
          <p className="new-terms__body">
            25.1 Your access to and use of the Services are at your own
            risk. You understand and agree that the Services are provided
            to you on an “AS IS” and “AS AVAILABLE” basis. Without limiting
            the foregoing, to the maximum extent permitted under applicable
            law, Autzu, its parents, affiliates, related companies,
            officers, directors, employees, agents, representatives,
            partners and licensors (the “Autzu Entities”) DISCLAIM ALL
            WARRANTIES AND CONDITIONS, WHETHER EXPRESS OR IMPLIED, OF
            MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE OR
            NON-INFRINGEMENT. The Autzu Entities make no warranty or
            representation and disclaim all responsibility and liability
            for: (a) the completeness, accuracy, availability, timeliness,
            security or reliability of the Services; (b) any harm to your
            computer system, loss of data, or other harm that results from
            your access to or use of the Services; (c) the operation or
            compatibility with any other application or any particular
            system or device; and (d) whether the Services will meet your
            requirements or be available on an uninterrupted, secure or
            error-free basis. No advice or information, whether oral or
            written, obtained from the Autzu Entities or through the
            Services, will create any warranty or representation not
            expressly made herein.
          </p>
        </ul>
        <h3 className="subheading">26. Limitations of Liability</h3>
        <ul>
          <p className="new-terms__body">
            26.1 TO THE MAXIMUM EXTENT NOT PROHIBITED BY LAW, EXCEPT FOR
            AUTZU’S FRAUD, GROSS NEGLIGENCE, OR WILLFUL MISCONDUCT, YOU
            AGREE THAT IN NO EVENT WILL THE AUTZU ENTITIES BE LIABLE FOR
            ANY LOSS OF USE, DATA OR PROFITS, BUSINESS INTERRUPTION OR FOR
            ANY, INDIRECT, SPECIAL, EXEMPLARY, INCIDENTAL, CONSEQUENTIAL OR
            PUNITIVE DAMAGES ARISING OUT OF OR RELATED TO YOUR USE OR
            INABILITY TO USE THE SERVICES OR THE VEHICLES), HOWEVER CAUSED
            AND UNDER ANY THEORY OF LIABILITY, WHETHER UNDER THIS AGREEMENT
            OR OTHERWISE ARISING IN ANY WAY IN CONNECTION WITH THE
            SERVICES, THE VEHICLES, OR THIS AGREEMENT AND WHETHER IN
            CONTRACT, STRICT LIABILITY OR TORT (INCLUDING NEGLIGENCE OR
            OTHERWISE) EVEN IF THE AUTZU ENTITIES HAVE BEEN ADVISED OF THE
            POSSIBILITY OF SUCH DAMAGE. SOME JURISDICTIONS (SUCH AS THE
            STATE OF NEW JERSEY) DO NOT ALLOW THE EXCLUSION OR LIMITATION
            OF INCIDENTAL OR CONSEQUENTIAL DAMAGES, SO THE ABOVE EXCLUSION
            OR LIMITATION MAY NOT APPLY TO YOU. THE AUTZU ENTITIES’ TOTAL
            LIABILITY TO YOU FOR ANY DAMAGES FINALLY AWARDED SHALL NOT
            EXCEED THE AMOUNT OF ONE HUNDRED DOLLARS ($100.00). THE
            FOREGOING LIMITATIONS WILL APPLY EVEN IF THE ABOVE STATED
            REMEDY FAILS OF ITS ESSENTIAL PURPOSE.
          </p>
        </ul>
        <h3 className="subheading">27. Indemnification</h3>
        <ul>
          <p className="new-terms__body">
            27.1 By entering into this Agreement and accessing or using the
            Services, you agree that you shall indemnify and hold the Autzu
            Entities harmless from and against any and all claims, costs,
            damages, losses, liabilities and expenses (including attorneys’
            fees and costs) incurred by the Autzu Entities arising out of
            or in connection with: (a) your violation or breach of this
            Agreement or any applicable law or regulation; (b) your
            violation of any rights of any third party; (c) your access to
            or use of the Services; and (d) your negligence or willful
            misconduct.
          </p>
        </ul>
        <h3 className="subheading">28. Arbitration and Governing Law</h3>
        <ul>
          <p className="new-terms__body">
            28.1 The parties shall endeavor to resolve any dispute arising
            out of, under, or related to this Agreement or the breach,
            termination, or validity thereof (the “Dispute”), by
            negotiation. Any Dispute which remains unresolved thirty (30)
            days after either party gives written notice of the existence
            of such Dispute shall be finally settled in a binding,
            confidential, individual, and fair arbitration process, and not
            in court. Each of you and Autzu agrees to give up the right to
            sue in court. The only exceptions are that each of you and
            Autzu retains the right to sue in small claims court for
            disputes or claims within the scope of its jurisdiction.
            Disputes over whether these exceptions apply shall be resolved
            by the court in which such action has been brought; all other
            disputes over arbitrability shall be resolved by the
            arbitrator. Each of you and Autzu also agrees to give up the
            ability to seek to represent, in a class action or otherwise,
            anyone but each of you and Autzu. There is no judge or jury in
            arbitration, and court review of an arbitration award is
            limited. An arbitrator must follow this Agreement. The
            arbitrator, however, can award on an individual basis the same
            damages and relief as a court (including injunctive and
            declaratory relief, or statutory damages).
          </p>
          <p className="new-terms__body">
            28.2 This Agreement evidences a transaction in interstate
            commerce, and thus the Federal Arbitration Act, U.S. Code Title
            9 Sections 1-16, governs the interpretation and enforcement of
            this Section 27.2. Section 27 shall survive termination of this
            Agreement.
          </p>
          <p className="new-terms__body">
            28.3 Any arbitration between you and Autzu will be conducted by
            JAMS pursuant to the JAMS Streamlined Arbitration Rules and
            Procedures (the “JAMS Rules”), as modified by this agreement to
            arbitrate. The arbitration shall be conducted by one arbitrator
            appointed in accordance with the JAMS Rules. The arbitration
            shall be conducted in English. The arbitration shall occur in
            New York, New York, but if you prefer a hearing closer to your
            hometown, the parties will confer in good faith in order to
            identify a reasonable alternative location. Judgment on the
            award may be entered in any court having jurisdiction. The JAMS
            Rules are available on its website at
            www.jamsadr.com/rules-streamlined-arbitration/. The JAMS
            Consumer Arbitration Minimum Standards, effective July 15,
            2009, are available at
            www.jamsadr.com/consumer-minimum-standards/. The arbitrator is
            bound by the terms of this Agreement.
          </p>
          <p className="new-terms__body">
            28.4 You and Autzu acknowledge and agree to abide by the
            following:
          </p>
          <ul>
            <p className="new-terms__body">
              28.4.1 The parties each agree that any dispute resolution
              proceedings will be conducted ONLY ON AN INDIVIDUAL BASIS AND
              NOT IN A CLASS, CONSOLIDATED, OR REPRESENTATIVE ACTION.
              Unless both parties agree otherwise, the arbitrator may not
              consolidate more than one person’s claims with your claims,
              and may not otherwise preside over any form of a
              representative or class proceeding. If this specific
              subsection (a) is found to be unenforceable, then the
              entirety of this arbitration provision will be null and void.
            </p>
            <p className="new-terms__body">
              28.4.2 The arbitrator may award declaratory or injunctive
              relief only in favor of the individual party seeking relief
              and only to the extent necessary to provide relief warranted
              by that party’s individual claim.
            </p>
            <p className="new-terms__body">
              28.4.3 Autzu will pay arbitration costs as required by the
              JAMS Consumer Arbitration Minimum Standards.
            </p>
            <p className="new-terms__body">
              28.4.4 If for any reason a claim proceeds in court rather
              than in arbitration, each party waives any right to a jury
              trial.
            </p>
            <p className="new-terms__body">
              28.4.5 You and the Autzu acknowledge and agree to abide by
              the following:
            </p>
            <p className="new-terms__body">
              28.4.6 Autzu and you agree that, if the damages alleged in
              good faith for the claims to be arbitrated total less than
              $10,000 (inclusive of attorneys’ fees), the claim ordinarily
              should be decided on written submissions only, without a
              telephonic or in-person hearing. Autzu will not request a
              hearing for any claims totaling less than $10,000. This
              provision shall not be construed by the arbitrator to deprive
              you of any rights you may have to a telephonic or in-person
              hearing in your hometown area pursuant to the JAMS Rules and
              the JAMS Consumer Arbitration Minimum Standards.
            </p>
            <p className="new-terms__body">
              28.4.7 Autzu and you agree that, if the damages alleged in
              good faith for the claims to be arbitrated total $10,000 or
              more, the arbitration will occur in a manner and place
              consistent with the JAMS Rules and the JAMS Consumer
              Arbitration Minimum Standards.
            </p>
            <p className="new-terms__body">
              28.4.8 Each of you and Autzu shall cooperate in good faith in
              the exchange of non-privileged documents and information as
              necessary in accordance with the JAMS Rules, and the
              arbitrator shall issue a reasoned written decision of the
              essential findings and conclusions on which the award is
              based.
            </p>
            <p className="new-terms__body">
              28.4.9 The parties undertake to keep confidential all awards
              in their arbitration, together with all materials in the
              proceedings created for the purpose of the arbitration and
              all other documents produced by another party in the
              proceedings not otherwise in the public domain, save and to
              the extent that disclosure may be required of a party by
              legal duty, to protect or pursue a legal right or to enforce
              or challenge an award in legal proceedings before a court or
              other judicial authority.
            </p>
            <p className="new-terms__body">
              28.4.10 With the exception of subpart (a) of this Section
              27.4 (i.e., the waiver of the ability to proceed on behalf of
              multiple claimants or a purported class), if any part of
              Section 27 is deemed invalid, unenforceable, or illegal, then
              the balance of Section 27 shall remain in effect and be
              construed in accordance with its terms as if the invalid,
              unenforceable, or illegal provision were not contained. If
              subpart (a) of this Section 27.4 is found invalid,
              unenforceable, or illegal, then Sections 27.1, 27.2, 27.3,
              and 27.4 shall be null and void, but the rest of this
              Agreement, including the provisions governing where actions
              against Autzu must be pursued, the choice of governing law,
              and our mutual waiver of the right to a trial by jury, will
              remain in effect and apply to any claim that, for this or any
              other reason, proceeds in court rather than in arbitration.
            </p>
          </ul>

          <p className="new-terms__body">
            28.5 This Agreement will be governed by and construed in
            accordance with the laws of New York without giving effect to
            any choice of laws principles that would require the
            application of the laws of a different country or state. For
            any and all claims, other than those in small claims court,
            jurisdiction for any court proceedings arising out of or
            relating to this Agreement will upon Autzu’s request be vested
            in, and venue will be in, the state or federal courts sitting
            in New York, New York, except that, following confirmation of
            an arbitration award in a state or federal court in New York,
            New York, a judgment arising from the same may be executed in
            any court of competent jurisdiction.
          </p>
          <p className="new-terms__body">
            28.6 YOU HEREBY KNOWINGLY, VOLUNTARILY AND INTENTIONALLY WAIVE
            ANY RIGHT YOU MAY HAVE TO A TRIAL BY JURY IN RESPECT OF ANY
            LITIGATION (INCLUDING, BUT NOT LIMITED TO, ANY CLAIMS,
            COUNTERCLAIMS, CROSS-CLAIMS, OR THIRD-PARTY CLAIMS) ARISING OUT
            OF, UNDER, OR RELATED TO THIS AGREEMENT.
          </p>
        </ul>
        <h3 className="subheading">29. Updating This Agreement</h3>
        <ul>
          <p className="new-terms__body">
            29.1 We may modify this Agreement from time to time, in which
            case we will update the “Last Revised” date at the top of this
            Agreement. If we make changes that are material, we will use
            reasonable efforts to attempt to notify you, such as by e-mail
            and/or by placing a prominent notice on the App. However, it is
            your sole responsibility to review this Agreement from time to
            time to view any such changes. The updated Agreement will be
            effective as of the time of posting, or such later date as may
            be specified in the updated Agreement. Your continued access or
            use of the Services after the modifications have become
            effective will be deemed your acceptance of the modified
            Agreement.
          </p>
        </ul>
        <h3 className="subheading">30. Miscellaneous</h3>
        <ul>
          <p className="new-terms__body">
            30.1 If any provision of this Agreement shall be unlawful, void
            or for any reason unenforceable, then that provision shall be
            deemed severable from this Agreement and shall not affect the
            validity and enforceability of any remaining provisions. The
            parties hereto are independent contractors. Neither party (nor
            any agent or employee of that party) is the representative of
            the other party for any purpose and neither party has the power
            or authority as agent, employee or in any other capacity to
            represent, act for, bind or otherwise create or assume any
            obligation on behalf of the other party for any purpose
            whatsoever. This Agreement and the licenses granted hereunder
            may be assigned by Autzu but may not be assigned by you without
            the prior express written consent of Autzu. No waiver by either
            party of any breach or default hereunder shall be deemed to be
            a waiver of any preceding or subsequent breach or default. The
            section headings used herein are for reference only and shall
            not be read to have any legal effect.
          </p>
        </ul>
        <h3 className="subheading">31. How to Contact Us</h3>
        <ul>
          <p className="new-terms__body">
            31.1 You may contact us regarding the Services or this
            Agreement by e-mail at info@autzu.com.
          </p>
        </ul>
        <br />
        <p
          className="new-terms__body"
          style={{ borderTop: 'solid 1px black' }}>
          Updated by The Autzu Legal Team on Aug 18, 2023
        </p>
      </div>
    </div>
  </div>
);

export default NewTermsContent;



// WEBPACK FOOTER //
// ./src/components/Static/NewTermsContent.js